import React from "react";
import "./EsgCo2.scss";
import { TrendingUpIcon, SecurityIcon, BusinessIcon, LegalIcon } from "../../../../../shared/cockpit/components/icons/Icon";
import { LuShieldCheck, LuUsers, LuLeaf, LuZap } from "react-icons/lu";

const EsgCo2: React.FC = () => {
  return (
    <div className="esg-co2">
      <div className="esg-co2__header">
        <div>
          <h2 className="esg-co2__title">Nachhaltigkeit & Pflichten</h2>
        </div>
        <p className="esg-co2__subtitle">
          ESG-Monitoring und Nachhaltigkeitsziele der Schmidt Gruppe (FitX,
          Spielstation, Immobilien).
        </p>
      </div>

      <div className="esg-co2__top-grid">
        <div className="esg-card esg-card--success">
          <div className="esg-card__header">
            <LuLeaf className="esg-card__icon--co2" /> CO2-EINSPARUNG (YTD)
          </div>
          <div className="esg-card__content">
            <div className="esg-card__value-group">
              <span className="esg-card__value">
                1.240 <small className="esg-card__unit">Tonnen</small>
              </span>
              <span className="esg-card__badge esg-card__badge--positive">
                +12% vs. Vorjahr
              </span>
            </div>
          </div>
        </div>

        <div className="esg-card esg-card--warning">
          <div className="esg-card__header">
            <LuZap className="esg-card__icon--green-energy" /> GREEN ENERGY MIX
          </div>
          <div className="esg-card__content">
            <div className="esg-card__value-group">
              <span className="esg-card__value">
                85 <small className="esg-card__unit">%</small>
              </span>
              <span className="esg-card__badge esg-card__badge--neutral">
                Ziel 2026: 90% (durch PV-Rollout)
              </span>
            </div>
          </div>
        </div>

        <div className="esg-card esg-card--primary">
          <div className="esg-card__header">
            <LuShieldCheck className="esg-card__icon--compliance" /> COMPLIANCE
            SCORE
          </div>
          <div className="esg-card__content">
            <div className="esg-card__value-group">
              <span className="esg-card__value">
                98 <small className="esg-card__unit">/ 100</small>
              </span>
              <span className="esg-card__badge esg-card__badge--audit">
                Audit Ready
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="esg-co2__middle-grid">
        <div className="environment-section">
          <div className="environment-section__header">
            <div className="environment-section__icon-wrapper">
              <LuLeaf />
            </div>
            <div className="environment-section__title-group">
              <h3 className="environment-section__title">
                Environment (Umwelt)
              </h3>
              <p className="environment-section__subtitle">
                Dekarbonisierung & Energieeffizienz
              </p>
            </div>
          </div>

          <div className="progress-item">
            <div className="progress-item__label-group">
              <span>Flotten-Elektrifizierung</span>
              <span>65%</span>
            </div>
            <div className="progress-item__bar-bg">
              <div className="progress-item__bar-fill progress-item__bar-fill--65"></div>
            </div>
            <p className="progress-item__desc">
              Umstellung Dienstwagenflotte auf BEV/PHEV
            </p>
          </div>

          <div className="progress-item">
            <div className="progress-item__label-group">
              <span>PV-Eigenstromquote (FitX Studios)</span>
              <span>42%</span>
            </div>
            <div className="progress-item__bar-bg">
              <div className="progress-item__bar-fill progress-item__bar-fill--42"></div>
            </div>
            <p className="progress-item__desc">
              Dachflächen-Nutzung & Speicher-Integration
            </p>
          </div>
        </div>

        <div className="social-section">
          <div className="social-section__header">
            <div className="social-section__icon-wrapper">
              <LuUsers />
            </div>
            <div className="social-section__title-group">
              <h3 className="social-section__title">Social (Soziales)</h3>
              <p className="social-section__subtitle">
                Mitarbeiter-Benefits & Verantwortung
              </p>
            </div>
          </div>

          <div className="social-list">
            <div className="social-item">
              <BusinessIcon className="social-item__icon" />
              <div className="social-item__content">
                <span className="social-item__name">
                  Home Charging Programm
                </span>
                <span className="social-item__desc">
                  Förderung von Wallboxen bei Mitarbeitern zuhause.
                </span>
                <span className="social-item__status">
                  Status: 124 aktive Teilnehmer
                </span>
              </div>
            </div>
            <div className="social-item">
              <SecurityIcon className="social-item__icon" />
              <div className="social-item__content">
                <span className="social-item__name">
                  Spielerschutz (Spielstation)
                </span>
                <span className="social-item__desc">
                  Zertifizierte Präventionsmaßnahmen und Schulungen.
                </span>
                <span className="social-item__status">
                  Status: 100% Compliance Rate
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="esg-co2__bottom-container">
        <div className="governance-section">
          <div className="governance-section__header">
            <LuShieldCheck />
            <div className="environment-section__title-group">
              <h3 className="environment-section__title">
                Governance (Unternehmensführung)
              </h3>
              <p className="environment-section__subtitle">
                Compliance, Datenschutz & Transparenz
              </p>
            </div>
          </div>

          <div className="governance-section__grid">
            <div className="gov-subcard">
              <div className="gov-subcard__label">Datenschutz</div>
              <div className="gov-subcard__main">
                <LuShieldCheck className="gov-subcard__icon" /> DSGVO Konform
              </div>
              <div className="gov-subcard__desc">
                Ladedaten & Mitarbeiterdaten
              </div>
            </div>
            <div className="gov-subcard gov-subcard--orange">
              <div className="gov-subcard__label">Steuern</div>
              <div className="gov-subcard__main">
                <LegalIcon className="gov-subcard__icon" /> § 9 GewStG Safe
              </div>
              <div className="gov-subcard__desc">Trennung Besitz/Betrieb</div>
            </div>
            <div className="gov-subcard gov-subcard--blue">
              <div className="gov-subcard__label">Reporting</div>
              <div className="gov-subcard__main">
                <TrendingUpIcon className="gov-subcard__icon" /> CSRD Ready
              </div>
              <div className="gov-subcard__desc">
                Nachhaltigkeitsberichterstattung
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EsgCo2;
